import { $Color, $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'ModuleArea';

export const ModuleArea = {
  SkillSets: tagEnum($, 1),
  JustTheFacts: tagEnum($, 2),
  Gyms: tagEnum($, 3),
  // WhatDoYouKnow: tagEnum($, 4),
  KnowAndShow: tagEnum($, 5),
  BonusGames: tagEnum($, 6),
  MeasurementWorld: tagEnum($, 7),
  K2World: tagEnum($, 8),
  VeryImportantFacts: tagEnum($, 9),
  ComputationalThinking: tagEnum($, 10),
} as const;

export type ModuleArea = TaggedEnumUnion<typeof ModuleArea>;

const ModuleAreas = {
  [$tag]: $,
  [ModuleArea.SkillSets]: {
    value: ModuleArea.SkillSets,
    slug: 'ss',
    label: 'Skill Sets',
    color: $Color.from('#ff3300'),
  },
  [ModuleArea.JustTheFacts]: {
    value: ModuleArea.JustTheFacts,
    slug: 'jtf',
    label: 'Just the Facts',
    color: $Color.from('#ffbe00'),
  },
  [ModuleArea.Gyms]: {
    value: ModuleArea.Gyms,
    slug: 'gyms',
    label: 'Workout Gyms',
    color: $Color.from('#d71155'),
  },
  [ModuleArea.KnowAndShow]: {
    value: ModuleArea.KnowAndShow,
    slug: 'ks',
    label: 'Know & Show',
    color: $Color.from('#1166ff'),
  },
  [ModuleArea.BonusGames]: {
    value: ModuleArea.BonusGames,
    slug: 'bonus',
    label: 'Bonus Games',
    color: $Color.from('#660099'),
  },
  [ModuleArea.MeasurementWorld]: {
    value: ModuleArea.MeasurementWorld,
    slug: 'mw',
    label: 'Measurement World',
    color: $Color.from('#ff8800'),
  },
  [ModuleArea.K2World]: {
    value: ModuleArea.K2World,
    slug: 'k2',
    label: 'K-2 World',
    color: $Color.from('#9933ff'),
  },
  [ModuleArea.VeryImportantFacts]: {
    value: ModuleArea.VeryImportantFacts,
    slug: 'vif',
    label: 'Very Important Facts',
    color: $Color.from('#00daff'),
  },
  [ModuleArea.ComputationalThinking]: {
    value: ModuleArea.ComputationalThinking,
    slug: 'ct',
    label: 'Computational Thinking',
    color: $Color.from('#ff55ff'),
  },
} as const;

export const $ModuleArea = buildStaticContext(ModuleAreas);
